var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighway(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.998,
    height: 45,
    viewBox: "0 0 44.998 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Highway",
    transform: "translate(-2 -1.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M31,2h1.5V4.987H31Zm0,17.921h1.5v2.987H31Zm0,5.974h1.5v2.987H31Zm0,5.974h1.5v2.987H31Zm0,5.974h1.5v2.987H31Zm0,5.974h1.5V46.8H31Z",
    transform: "translate(-7.251 -0.033)",
    fill: "#ffc448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M46.248,16.9a.748.748,0,0,0,.75-.747V8.687a.748.748,0,0,0-.75-.747H37.305l-.814-6.072L35,2.065l.787,5.875H34.305l-.814-6.072-1.486.2.787,5.875H16.206l.787-5.875-1.486-.2L14.692,7.94H13.206l.787-5.875-1.486-.2L11.692,7.94H2.75A.748.748,0,0,0,2,8.687v7.467a.748.748,0,0,0,.75.747H3.5V27.355H2v1.493H6.5V27.355H5V16.9h5.5L6.507,46.671l1.486.2L12.009,16.9H13.5L9.506,46.671l1.486.2L15.009,16.9h18.98L38,46.868l1.486-.2L35.5,16.9h1.486L41,46.868l1.486-.2L38.5,16.9H44V27.355H42.5v1.493H47V27.355H45.5V16.9ZM3.5,9.434h42v5.974H3.5Z",
    fill: "#ffc448"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M12,15h6v1.5H12Zm24,0h6v1.5H36ZM24,15h6v1.5H24Z",
    transform: "translate(-2.5 -3.328)",
    fill: "#ffc448"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighway);
export default __webpack_public_path__ + "static/media/Highway.4392cf81134dffbe02a1fefbbabb8b93.svg";
export { ForwardRef as ReactComponent };